var _circle, _ellipse, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#EEEEEE"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 16.1948,
    cy: 16.124,
    rx: 6.01071,
    ry: 6.01071,
    fill: "#1E2023"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1442 12.5767L15.1426 16.569C15.1426 16.7206 15.2028 16.8655 15.3098 16.9725L18.1658 19.828L18.9727 19.021L16.2839 16.3327L16.2855 12.5767L15.1442 12.5767Z",
    fill: "#1E2023"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2857 8C12.2635 8 8.93458 10.9872 8.37704 14.8571H6L8.85714 17.7143L11.7143 14.8571H9.53179C10.0785 11.6193 12.8946 9.14287 16.2857 9.14287C20.0669 9.14287 23.1429 12.2188 23.1429 16C23.1429 19.7813 20.067 22.8572 16.2857 22.8572C14.1602 22.8572 12.1892 21.8951 10.8783 20.2176L9.97768 20.9208C11.5067 22.8772 13.8058 24 16.2857 24C20.697 24 24.2857 20.4107 24.2857 16C24.2857 11.5893 20.697 8.00003 16.2857 8L16.2857 8Z",
    fill: "#1E2023"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.26f44bb8fc71364993b80c0fe2965c91.svg";
export { ForwardRef as ReactComponent };